import { useState, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';
import { toast } from 'sonner';

export function useTwoFactorAuth() {
  const [show2FA, setShow2FA] = useState(false);
  const [userInfo, setUserInfo] = useState<{
    userId: string;
    email: string;
    userName: string;
    password: string;
  } | null>(null);

  const check2FARequired = useCallback(async (userId: string) => {
    try {
      const { data: settings } = await supabase
        .from('user_settings')
        .select('two_factor_enabled')
        .eq('user_id', userId)
        .single();

      return settings?.two_factor_enabled || false;
    } catch (error) {
      console.error('Error checking 2FA status:', error);
      return false;
    }
  }, []);

  const initiate2FA = useCallback(async (userId: string, email: string, userName: string, password: string) => {
    console.log('Initiating 2FA flow - setting state immediately');
    
    // Definir estado de forma SÍNCRONA e IMEDIATA
    setUserInfo({ userId, email, userName, password });
    setShow2FA(true);
    
    console.log('2FA state set, userInfo and show2FA are now true');
    
    // Enviar código em segundo plano (não bloqueia o estado)
    supabase.functions.invoke('send-2fa-code', {
      body: { userId, email, userName },
    }).then(() => {
      console.log('2FA code sent successfully');
    }).catch((error: any) => {
      console.error('Error sending 2FA code:', error);
      toast.error('Erro ao enviar código: ' + error.message);
    });
  }, []);

  const cancel2FA = useCallback(async () => {
    // Limpar estado e fazer logout
    setShow2FA(false);
    setUserInfo(null);
    await supabase.auth.signOut();
    console.log('2FA cancelled, user logged out');
  }, []);

  const complete2FA = useCallback(() => {
    setShow2FA(false);
    setUserInfo(null);
  }, []);

  return {
    show2FA,
    userInfo,
    check2FARequired,
    initiate2FA,
    cancel2FA,
    complete2FA,
  };
}